module.exports = __webpack_public_path__ + "static/media/Enjoy the Ride Cover Art.bc2d380c.jpg";